<template>
  <div class="wrapp-first-choice">
    <div class="ck-card-title"><span class="column-count" v-show="columnCount">{{columnCount}}</span>{{ $t('collect-method') }}</div>
    <b-form-group>
      <b-form-radio-group
      v-validate="'required'"
      stacked
      v-model="selected"
      :name="name"
      @change="changeChoice">
        <b-form-radio value="ClickAndCollect">
          <span class="text">{{ $t('pickup-in-store') }}</span>
          <svg class="o-icon fill-white stroke-black"><use xlink:href="#your-shop"></use></svg>
        </b-form-radio>
        <template v-if="selected === 'ClickAndCollect'">
          <store-picker ref="store-picker" />
        </template>
        <b-form-radio value="address">
          <span class="text">{{ $t('anywere-you-wish') }}</span>
          <svg class="o-icon"><use xlink:href="#map-pin-2-line"></use></svg>
        </b-form-radio>
      </b-form-radio-group>
      <b-form-invalid-feedback :class="{ 'd-block': errors.has(name) }" class="position-relative">
        <span>{{ errors.first(name) }}</span>
      </b-form-invalid-feedback>
    </b-form-group>
  </div>
</template>

<script>
import find from 'lodash/find'
import { EventBus, graphqlManageError } from '@/helpers'
import { toast } from 'theme/modules/notifications'
import StorePicker from 'theme/components/StorePickup/StorePicker'
import Logger from '@/services/Logger'

export default {
  name: 'FakeChoice',
  props: {
    columnCount: {
      type: String
    },
    busListener: {
      type: String,
      required: false
    },
    name: {
      type: String,
      default: () => 'fake-choice-form'
    }
  },
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      selected: ''
    }
  },
  methods: {
    storeChoice (choice) {
      global.$cookies.set('latest-delivery-choice', choice)
    },
    changeChoice ($event) {
      this.storeChoice($event)
      this.$emit('choiceChanged', $event)
    },
    confirmData () {
      const _this = this
      if (_this.selected === 'ClickAndCollect') {
        this.$refs['store-picker'].$validator.validate()
          .then((isValid) => {
            if (isValid) {
              _this.$validator.validateAll().then(isValid => {
                if (isValid) {
                  // read store code from cookie
                  let storeCode = global.$cookies.get('pickup-store-code')
                  if (storeCode) {
                    // set storeCode and ship to store to checkout
                    // because we need to send it to order
                    this.setPickupOnCart(storeCode)
                  }
                }
              })
            }
          })
      } else {
        this.$validator.validate()
          .then((isValid) => {
            if (isValid) {
              if (_this.selected === 'address') {
                // reset  storeCode and ship to store to checkout
                // because we need to send it to order
                _this.setClassicAddressOnCart()
              }
            }
          })
      }
    },
    isPickup (carrierCode) {
      let shippingMethods = this.$store.state.checkout.shippingMethods
      let method = find(shippingMethods, { carrier_code: this.selected })
      this.setShippingMethod(method, carrierCode)
    },
    setShippingMethod (method, carrierCode) {
      console.log('BLOCCO! SET SHIPPING METHOD IN PICKUP')
      console.log('BLOCCO! SHIPPING METHODS CABLATI')
      console.log(method)
      return this.$store.dispatch('checkout/setShippingMethods', {
        carrier_title: method.method_title,
        carrier_code: method.carrier_code,
        method_code: method.carrier_code,
        method_title: method.method_title,
        amount: method.amount.value
      })
        .catch(error => {
          console.log('error save shipping method')
          const msg = graphqlManageError(error) ? this.$t(graphqlManageError(error)) : this.$t('GenericError')
          toast.error(msg)
          Logger.error('error save shipping method ', error)
        })
        .finally(() => {
          EventBus.$emit('checkout:updResume')
        })
    },
    setPickupOnCart (storeCode) {
      const _this = this
      this.$store.commit('ui/showLoader')
      // get id from store code ex 10 from MI_IT
      this.$store.commit('checkout/setShipStoreId', storeCode)
      this.$store.commit('checkout/setShipToStore', true)
      return this.$store.dispatch('storeLocator/getPickupIdFromLocation', storeCode)
        .then((pickupId) => {
          // pickupId=14
          // set id in cart
          return _this.$store.dispatch('checkout/setPickupIdOnCart', pickupId)
            .then(() => {
              // get boutique info from store code
              return _this.$store.dispatch('storeLocator/getBoutique', storeCode)
                .then((boutique) => {
                  // set shipping address of boutique as default shipping address
                  return _this.$store.dispatch('checkout/setPickupAddress', boutique)
                    .then(() => {
                      // call EventBus to set shipping methods active (listener is on ShippingMethodForm.vue)
                      // call isPickup to set shipping method on cart
                      // emit event to set pickup on checkout page
                      // emit event to go on next step
                      EventBus.$emit('fakeChoice:isPickupEnable', { enabled: true, carrierCode: _this.selected })
                      _this.isPickup(_this.selected)
                      _this.$emit('isPickupSelected', true)
                      _this.$emit('next-step')
                    })
                    .catch((error) => {
                      let msg = graphqlManageError(error) || 'GenericError'
                      toast.error(this.$t(msg))
                      // fill out store selected
                      this.$refs['store-picker'] && this.$refs['store-picker'].resetCurrentStore()
                    })
                })
            })
        })
        .finally(() => {
          _this.$store.commit('ui/hideLoader')
        })
    },
    setClassicAddressOnCart () {
      // set loader on
      // set shipping on cart TODO: understand if is possible set an empty shipping
      // reset shippingAddress to default -> empty
      // call component to force resetting (becouse on checkout mounted address was already set)
      // call EventBus to set shipping methos active (listener is on ShippingMethodForm.vue)
      // emit event to set pickup on checkout page
      // emit event to go on next step
      const resetShippingMethod = () => {
        this.$store.commit('checkout/setShippingAddress', null)
        this.$emit('isPickupSelected', false)
        this.$store.commit('checkout/setShipStoreId', '')
        this.$store.commit('checkout/setShipToStore', false)
      }

      // let shippingMethods = this.$store.state.checkout.shippingMethods
      // if (shippingMethods && shippingMethods.length) {
      //   this.$store.commit('ui/showLoader')
      //   this.setShippingMethod('flatrate', 'flatrateone')
      //     .then(() => {
      //       EventBus.$emit('fakeChoice:isPickupEnable', { enabled: false, carrierCode: 'flatrateone' })
      //       resetShippingMethod()
      //       this.$emit('next-step')
      //     })
      //     .finally(() => {
      //       this.$store.commit('ui/hideLoader')
      //     })
      // } else {
      //   resetShippingMethod()
      //   this.$emit('next-step')
      // }
      resetShippingMethod()
      this.$emit('next-step')
    }
  },
  mounted () {
    if (this.busListener) {
      EventBus.$on(`${this.busListener}:validateForm`, this.confirmData)
    }
    // active first choice using changechoice method to replace user click
    EventBus.$on(`fakeChoice:setPickup`, this.isPickup)
    let latestChoice = global.$cookies.get('latest-delivery-choice') || 'ClickAndCollect'
    if (latestChoice) {
      this.selected = latestChoice
      this.changeChoice(latestChoice)
    }
  },
  destroyed () {
    if (this.busListener) {
      EventBus.$off(`${this.busListener}:validateForm`, this.confirmData)
    }
    EventBus.$off('fakeChoice:setPickup', this.isPickup)
  },
  components: {
    StorePicker
  }
}
</script>
